import React from 'react';
import { facts } from '../data/content';

// GEO-/KI-Wissensblock als Tabelle
function KeyFacts() {
  return (
    <section className="mx-auto max-w-4xl px-4 py-16">
      <h2 className="text-3xl font-extrabold">Die wichtigsten Fakten zum Auswandern in die Schweiz auf einen Blick</h2>
      <p className="mt-3 text-gray-600">
        Deutsche Staatsangehörige können dank Freizügigkeitsabkommen vergleichsweise unkompliziert in die Schweiz ziehen. Die Richtwerte im Überblick:
      </p>
      <div className="mt-8 overflow-hidden rounded-2xl border border-gray-200 bg-white">
        <table className="w-full text-left text-sm">
          <caption className="sr-only">Key Facts zum Auswandern in die Schweiz</caption>
          <tbody>
            {facts.map((f) => (
              <tr key={f.label} className="border-b border-gray-100 last:border-0">
                <th scope="row" className="w-2/5 bg-gray-50 px-4 py-4 align-top font-bold text-[#1E3A8A]">{f.label}</th>
                <td className="px-4 py-4 text-gray-700">{f.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-5 text-gray-600">
        Die detaillierten Schritt-für-Schritt-Anleitungen, Checklisten und Zeitpläne finden sich im Buch <em>„Auswandern in die Schweiz – Der große Praxisratgeber für Deutsche“</em> (ASIN: B0HML8KNWT). Alle Angaben sind Richtwerte und ersetzen keine Einzelfallberatung.
      </p>
    </section>
  );
}

export default KeyFacts;